import styled from '@emotion/styled';
import clsx from 'clsx';

import { Typography } from '../typography';

import type { TypographyProps } from '../typography';
import type { AnchorHTMLAttributes, FC } from 'react';

export type LinkProps = AnchorHTMLAttributes<HTMLAnchorElement> & TypographyProps;

const StyledLink = styled(Typography)`
  display: inline-block;
  padding: ${({ theme }) => theme.spacing(0, 1)};
  text-decoration: underline;

  &:focus {
    outline: 4px solid ${({ theme }) => theme.palette.colors.focus};
  }
`;

const StyledLegacyLink = styled.a`
  text-decoration: none;
  color: inherit;
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  font-size: inherit;
  line-height: inherit;
  padding: ${({ theme }) => theme.spacing(1)};
  border-bottom: 3px solid ${({ theme }) => theme.palette.colors.yellow[400]};
  cursor: pointer;
`;

type LegacyLinkProps = AnchorHTMLAttributes<HTMLAnchorElement> & CustomLinkProps;

type CustomLinkProps = {
  disabled?: boolean;
  inverted?: boolean;
};

// !Todo: remove Legacy link after all active widgets have been migrated to use the new customizable Link
const LegacyLink: FC<LegacyLinkProps> = (props) => {
  const { className, inverted, disabled, ...otherProps } = props;
  const classNames = clsx(className, { inverted, disabled });

  return <StyledLegacyLink className={classNames} {...otherProps} />;
};

export const Link: FC<LinkProps> = (props) => {
  if (props.variant) return <StyledLink {...props} as="a" />;

  return <LegacyLink {...props} />;
};
